/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {state} from '@/store/modules/user-session';
import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';

/**
 * Authentication route guard.
 *
 * Note: if the jwt token is not undefined or empty then it is presumed that the JWT is valid.
 *
 * @param to
 * @param from
 * @param next
 */
export const authenticated: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    if (undefined === state.session.token || '' === state.session.token) {
        next('/login');
        return;
    }

    if (state.session.expiry < (new Date().getDate())) {
        next('/login');
        return;
    }

    next();
};
